import React from 'react';

import { TopMenuDropdown } from 'editor/src/store/app/types';

import IconOpacity from 'editor/src/component/Icon/IconOpacity';
import ImageOpacityControl from 'editor/src/component/ImageOpacityControl';
import { MenuItemProps } from 'editor/src/component/Menu/type';
import ButtonWithDropdownNotWrapped from 'editor/src/component/TopMenuDesktop/buttons/ButtonWithDropdownNotWrapped';
import MenuDropDownButton from 'editor/src/component/TopMenuDesktop/buttons/MenuDropDownButton';

function ButtonImageOpacityDropDown({ mode }: MenuItemProps) {
  return (
    <ButtonWithDropdownNotWrapped
      dropDownName={TopMenuDropdown.ImageOpacity}
      buttonExtraClass="cy-button-image-opacity"
      dropDownContent={<ImageOpacityControl />}
      buttonContent={<MenuDropDownButton Icon={IconOpacity} mode={mode} i18nKey="editor-opacity" />}
    />
  );
}

export default React.memo(ButtonImageOpacityDropDown);
